var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [{ "search-appeared": _vm.display.search }],
      staticStyle: { height: "100%" }
    },
    [
      _c("header", { staticClass: "row align-items-center no-margin" }, [
        _vm.display.search
          ? _c("div", {
              staticClass: "overlay-disabled",
              on: {
                click: function($event) {
                  return _vm.setPosDisplay({ search: false })
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col text-white" }, [
          _vm._v("\n      " + _vm._s(_vm.branch.name) + "\n    ")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col text-right" }, [
          _c(
            "div",
            { staticClass: "dropdown show" },
            [
              _c(
                "vs-tooltip",
                {
                  attrs: {
                    text: _vm.$t("message.exit"),
                    color: "zindex-5",
                    position: "bottom"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn no-bg",
                      on: { click: _vm.onBackToDashboard }
                    },
                    [_c("i", { staticClass: "fas fa-power-off" })]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown show" },
            [
              !_vm.isOffline
                ? _c(
                    "vs-tooltip",
                    {
                      attrs: {
                        text:
                          _vm.bills.length > 0
                            ? _vm.$t("message.transactionswillsaveauto", {
                                number: _vm.bills.length
                              })
                            : _vm.networkMessage,
                        color: "zindex-5",
                        position: "bottom"
                      }
                    },
                    [
                      _vm.bills.length > 0
                        ? _c("div", { staticClass: "count" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.bills.length) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn no-bg",
                          staticStyle: { cursor: "default" }
                        },
                        [_c("i", { staticClass: "fas fa-wifi" })]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isOffline
                ? _c(
                    "vs-tooltip",
                    {
                      attrs: {
                        text:
                          _vm.bills.length > 0
                            ? _vm.$t("message.transactionswillsaveauto", {
                                number: _vm.bills.length
                              })
                            : _vm.networkMessage,
                        color: "zindex-5",
                        position: "bottom"
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn no-bg",
                          staticStyle: { cursor: "default" }
                        },
                        [
                          _vm.bills.length > 0
                            ? _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.bills.length) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-wifi text-danger" })
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.posSettings.menu_online.is_active
            ? _c(
                "div",
                { staticClass: "dropdown show" },
                [
                  _c(
                    "vs-tooltip",
                    {
                      attrs: {
                        text: _vm.$t("apps.pos.message.createnewqrcode"),
                        position: "bottom",
                        color: "zindex-5"
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn no-bg",
                          on: { click: _vm.handleOpenCreateQRCodeForm }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-qrcode",
                            staticStyle: {
                              "font-size": "18px",
                              position: "relative",
                              top: "2px"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.posSettings.menu_online.is_active
            ? _c(
                "div",
                { staticClass: "dropdown show" },
                [
                  _c(
                    "vs-tooltip",
                    {
                      attrs: {
                        text: _vm.$t("message.notifications"),
                        position: "bottom",
                        color: "zindex-5"
                      }
                    },
                    [
                      _c("BaseNotificationBell", {
                        attrs: {
                          id: "notification-bell",
                          count: _vm.unreadNotificationCount
                        },
                        on: { onClick: _vm.handleClickNotificationBell }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.posSession
            ? _c(
                "div",
                {
                  staticClass: "dropdown show",
                  staticStyle: { width: "auto" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn no-bg",
                      staticStyle: {
                        cursor: "default",
                        "font-size": "12px",
                        position: "relative",
                        top: "11px"
                      }
                    },
                    [
                      _c(
                        "vs-tooltip",
                        {
                          staticStyle: { float: "left" },
                          attrs: {
                            text: _vm.$t("apps.pos.message.possession"),
                            color: "zindex-5",
                            position: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: { position: "relative", top: "-8px" }
                            },
                            [_vm._v(_vm._s(_vm.posSession.ps_code))]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "categories-section" }, [
        _vm.display.search
          ? _c("div", {
              staticClass: "overlay-disabled",
              on: {
                click: function($event) {
                  return _vm.setPosDisplay({ search: false })
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "wrapper-cat", attrs: { col: "" } },
          _vm._l(_vm.products, function(item, index) {
            return item.productsCount > 0 ||
              ["1", "2"].includes(item.category_id)
              ? _c(
                  "li",
                  {
                    key: index,
                    staticClass: "item row no-margin",
                    class: { active: item.category_id == _vm.category_id },
                    on: {
                      click: function($event) {
                        return _vm.changePosCategory(item.category_id)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-8",
                        staticStyle: { "padding-right": "0" }
                      },
                      [
                        item.category_id == "1"
                          ? _c("span", [
                              _c("i", {
                                staticClass: "fas fa-star",
                                staticStyle: { width: "18px", color: "#F7A621" }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.favorite")) +
                                  "\n          "
                              )
                            ])
                          : item.category_id == "2"
                          ? _c("span", [
                              _c("i", {
                                staticClass: "fas fa-cubes",
                                staticStyle: { width: "18px" }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.all")) +
                                  "\n          "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.category_name) +
                                  "\n          "
                              )
                            ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-4 text-right",
                        staticStyle: { "padding-left": "0" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.productsCount) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "products-section" }, [
        _c("div", { staticClass: "top-bar row" }, [
          !_vm.display.search
            ? _c("ul", { staticClass: "wrapper-viewtype col" }, [
                _c(
                  "li",
                  {
                    staticClass: "row align-items-center",
                    class: { active: _vm.display.type == "grid" },
                    on: {
                      click: function($event) {
                        return _vm.setPosDisplay({ type: "grid" })
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-th col" })]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "row align-items-center",
                    class: { active: _vm.display.type == "list" },
                    on: {
                      click: function($event) {
                        return _vm.setPosDisplay({ type: "list" })
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-th-list col" })]
                ),
                _vm._v(" "),
                _vm.showDiscountButton
                  ? _c(
                      "li",
                      {
                        staticClass: "row align-items-center",
                        class: { active: _vm.display.type == "discount" },
                        on: {
                          click: function($event) {
                            return _vm.setPosDisplay({ type: "discount" })
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-tag col" })]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row align-items-center title col",
              class: [{ "text-center": !_vm.display.search }]
            },
            [
              [
                _vm._l(_vm.products, function(item, index) {
                  return item.category_id == _vm.category_id &&
                    !_vm.display.search
                    ? _c(
                        "div",
                        { staticClass: "col" },
                        [
                          item.category_id == "1"
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("message.favorite")) +
                                    "\n            "
                                )
                              ])
                            : item.category_id == "2"
                            ? _c(
                                "span",
                                [
                                  ["grid", "list"].includes(_vm.display.type)
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.pos.message.allproducts"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("message.discount")) +
                                            "\n              "
                                        )
                                      ]
                                ],
                                2
                              )
                            : _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.category_name) +
                                    "\n            "
                                )
                              ]),
                          _vm._v(" "),
                          ["grid", "list"].includes(_vm.display.type)
                            ? [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(item.productsCount) +
                                    ")\n            "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(_vm.filterDiscounts.length) +
                                    ")\n            "
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.display.search
                  ? _c("div", { staticClass: "col" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.resultsearch")) +
                          ": " +
                          _vm._s(_vm.resultSearchCount) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "action col" },
            [
              _vm.display.type != "discount"
                ? [
                    !_vm.display.search
                      ? _c(
                          "li",
                          {
                            staticClass: "row align-items-center",
                            on: {
                              click: function($event) {
                                return _vm.setPosDisplay({ search: true })
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-search col" })]
                        )
                      : _c("li", { staticClass: "row align-items-center" }, [
                          _c("div", { staticClass: "wp-search" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-close",
                                on: {
                                  click: function($event) {
                                    return _vm.setPosDisplay({ search: false })
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-times" })]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.txtFieldSearch,
                                  expression: "txtFieldSearch"
                                }
                              ],
                              ref: "txtfield-search",
                              staticClass: "form-control form-control-sm",
                              attrs: {
                                placeholder: _vm.$t("placeholder.search"),
                                type: "text"
                              },
                              domProps: { value: _vm.txtFieldSearch },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.txtFieldSearch = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.display.type == "grid"
          ? _c(
              "div",
              { staticClass: "container-items grid" },
              [
                _vm.notfound
                  ? _c("BaseNotFoundData", {
                      attrs: {
                        title: _vm.$t("apps.pos.message.notfoundproducts"),
                        detail: _vm.$t("apps.pos.message.createnewproduct")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.filterProducts, function(item, index) {
                  return item.category_id == _vm.category_id
                    ? _c(
                        "div",
                        {
                          staticClass: "wrapper-items",
                          staticStyle: { height: "100%" }
                        },
                        [
                          _c("RecycleScroller", {
                            staticClass: "scroller",
                            attrs: {
                              items: item.products,
                              itemSize: _vm.gridHeight,
                              gridItems: 6,
                              itemSecondarySize: _vm.gridWidth,
                              keyField: "product_id"
                            },
                            on: { ready: _vm.setRecycleScrollerGridUI },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var product = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "outer-item",
                                          class: [
                                            {
                                              disabled:
                                                _vm.isSinglePriceAndIsNotAvailable(
                                                  product
                                                ) ||
                                                _vm.isSinglePriceAndOutOfStock(
                                                  product
                                                )
                                            }
                                          ],
                                          staticStyle: { width: "100%" },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectedProduct(
                                                product
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "top-bar-icon text-right"
                                            },
                                            [
                                              [
                                                _vm.isSinglePriceAndIsNotAvailable(
                                                  product
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-danger",
                                                        staticStyle: {
                                                          "font-size": "9px",
                                                          position: "relative",
                                                          top: "-1px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.productisnotavailable"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isSinglePriceAndOutOfStock(
                                                  product
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-danger",
                                                        staticStyle: {
                                                          "font-size": "9px",
                                                          position: "relative",
                                                          top: "-1px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.outofstock"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              _vm._v(" "),
                                              [
                                                _vm.isSyncWithWarehouse(product)
                                                  ? _c(
                                                      "vs-tooltip",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 3px",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          text: _vm
                                                            .$t(
                                                              "apps.inventory.message.stockquantity"
                                                            )
                                                            .toLowerCase(),
                                                          position: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-secondary",
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                              position:
                                                                "relative",
                                                              top: "0px"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-box-open",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                position:
                                                                  "relative",
                                                                top: "1px"
                                                              }
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.stockCount(
                                                                    product
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.isCustomAttr(product) &&
                                                _vm.isProductUseLot(product)
                                                  ? _c(
                                                      "vs-tooltip",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 3px",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          text: _vm
                                                            .$t(
                                                              "message.chooselot"
                                                            )
                                                            .toLowerCase(),
                                                          position: "top"
                                                        }
                                                      },
                                                      [
                                                        _vm.isSyncWithWarehouse(
                                                          product
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge badge-secondary"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-pallet",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "12px",
                                                                    position:
                                                                      "relative",
                                                                    top: "1px"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.isCustomAttr(product) &&
                                                _vm.isProductUseSerial(product)
                                                  ? _c(
                                                      "vs-tooltip",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 3px",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          text: _vm
                                                            .$t(
                                                              "message.chooseserial"
                                                            )
                                                            .toLowerCase(),
                                                          position: "top"
                                                        }
                                                      },
                                                      [
                                                        _vm.isSyncWithWarehouse(
                                                          product
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge badge-secondary"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-sd-card",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "12px",
                                                                    position:
                                                                      "relative",
                                                                    top: "1px"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isCustomPrice(product) &&
                                                !_vm.isSinglePriceAndIsNotAvailable(
                                                  product
                                                ) &&
                                                !_vm.isSinglePriceAndOutOfStock(
                                                  product
                                                )
                                                  ? _c(
                                                      "vs-tooltip",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 3px",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          text: _vm
                                                            .$t(
                                                              "message.customprice"
                                                            )
                                                            .toLowerCase(),
                                                          position: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-secondary"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-calculator",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                position:
                                                                  "relative",
                                                                top: "1px"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isCustomAttr(product) &&
                                                !_vm.isSinglePriceAndIsNotAvailable(
                                                  product
                                                ) &&
                                                !_vm.isSinglePriceAndOutOfStock(
                                                  product
                                                )
                                                  ? _c(
                                                      "vs-tooltip",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 3px",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          text: _vm
                                                            .$t(
                                                              "message.chooseattribute"
                                                            )
                                                            .toLowerCase(),
                                                          position: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-secondary"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-tasks",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                position:
                                                                  "relative",
                                                                top: "1px"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item col",
                                              class: [
                                                {
                                                  active: _vm.isSelectedProduct(
                                                    product.product_id
                                                  )
                                                }
                                              ]
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "img" },
                                                [
                                                  _c("img", {
                                                    staticClass: "img-fluid",
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      src:
                                                        product.images
                                                          .original ||
                                                        _vm.defaultImages
                                                          .product
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "name" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        product.product_name
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "hint" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.pressentertoselect"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.display.type == "list"
          ? _c(
              "div",
              { staticClass: "container-items list" },
              [
                _vm.notfound
                  ? _c("BaseNotFoundData", {
                      attrs: {
                        title: _vm.$t("apps.pos.message.notfoundproducts"),
                        detail: _vm.$t("apps.pos.message.createnewproduct")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.filterProducts, function(item, index) {
                  return item.category_id == _vm.category_id
                    ? _c(
                        "ul",
                        {
                          staticClass: "wrapper-items",
                          staticStyle: { height: "100%" }
                        },
                        [
                          _c("RecycleScroller", {
                            staticClass: "scroller",
                            attrs: {
                              items: item.products,
                              itemSize: 62,
                              keyField: "product_id"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var product = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "outer-item",
                                          class: [
                                            {
                                              disabled:
                                                _vm.isSinglePriceAndIsNotAvailable(
                                                  product
                                                ) ||
                                                _vm.isSinglePriceAndOutOfStock(
                                                  product
                                                )
                                            }
                                          ],
                                          staticStyle: { width: "100%" },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectedProduct(
                                                product
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "item col-12 row no-margin",
                                              class: [
                                                {
                                                  active: _vm.isSelectedProduct(
                                                    product.product_id
                                                  )
                                                }
                                              ]
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "img" },
                                                [
                                                  _c("img", {
                                                    staticClass: "img-fluid",
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      src:
                                                        product.images
                                                          .thumbnail ||
                                                        _vm.defaultImages
                                                          .product,
                                                      width: "48",
                                                      height: "48"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "details row no-margin align-items-center"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-left pname col-8",
                                                      staticStyle: {
                                                        height: "100%",
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        "justify-content":
                                                          "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "_pname",
                                                          staticStyle: {
                                                            float: "left",
                                                            "margin-right":
                                                              "10px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              product.product_name
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        [
                                                          _vm.isSyncWithWarehouse(
                                                            product
                                                          )
                                                            ? _c(
                                                                "vs-tooltip",
                                                                {
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    margin:
                                                                      "0 2px"
                                                                  },
                                                                  attrs: {
                                                                    text: _vm
                                                                      .$t(
                                                                        "apps.inventory.message.stockquantity"
                                                                      )
                                                                      .toLowerCase(),
                                                                    position:
                                                                      "top"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "badge badge-secondary",
                                                                      staticStyle: {
                                                                        height:
                                                                          "15px",
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center",
                                                                        "justify-content":
                                                                          "center",
                                                                        "font-size":
                                                                          "9px",
                                                                        position:
                                                                          "relative",
                                                                        top:
                                                                          "-1px",
                                                                        "margin-left":
                                                                          "-1px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-box-open",
                                                                        staticStyle: {
                                                                          "margin-right":
                                                                            "2px"
                                                                        }
                                                                      }),
                                                                      _vm._v(
                                                                        "\n                          " +
                                                                          _vm._s(
                                                                            _vm.stockCount(
                                                                              product
                                                                            )
                                                                          ) +
                                                                          "\n                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.isCustomPrice(
                                                            product
                                                          ) &&
                                                          !_vm.isSinglePriceAndIsNotAvailable(
                                                            product
                                                          ) &&
                                                          !_vm.isSinglePriceAndOutOfStock(
                                                            product
                                                          )
                                                            ? _c(
                                                                "vs-tooltip",
                                                                {
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    margin:
                                                                      "0 3px",
                                                                    cursor:
                                                                      "pointer"
                                                                  },
                                                                  attrs: {
                                                                    text: _vm
                                                                      .$t(
                                                                        "message.customprice"
                                                                      )
                                                                      .toLowerCase(),
                                                                    position:
                                                                      "top"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "badge badge-secondary",
                                                                      staticStyle: {
                                                                        height:
                                                                          "15px",
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center",
                                                                        "justify-content":
                                                                          "center",
                                                                        "font-size":
                                                                          "9px",
                                                                        position:
                                                                          "relative",
                                                                        top:
                                                                          "-1px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-calculator"
                                                                      })
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.isCustomAttr(
                                                            product
                                                          ) &&
                                                          _vm.isProductUseLot(
                                                            product
                                                          )
                                                            ? _c(
                                                                "vs-tooltip",
                                                                {
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    margin:
                                                                      "0 2px",
                                                                    cursor:
                                                                      "pointer"
                                                                  },
                                                                  attrs: {
                                                                    text: _vm
                                                                      .$t(
                                                                        "message.chooselot"
                                                                      )
                                                                      .toLowerCase(),
                                                                    position:
                                                                      "top"
                                                                  }
                                                                },
                                                                [
                                                                  _vm.isSyncWithWarehouse(
                                                                    product
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "badge badge-secondary",
                                                                          staticStyle: {
                                                                            height:
                                                                              "15px",
                                                                            display:
                                                                              "flex",
                                                                            "align-items":
                                                                              "center",
                                                                            "justify-content":
                                                                              "center",
                                                                            "font-size":
                                                                              "9px",
                                                                            position:
                                                                              "relative",
                                                                            top:
                                                                              "-1px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-pallet"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.isCustomAttr(
                                                            product
                                                          ) &&
                                                          _vm.isProductUseSerial(
                                                            product
                                                          )
                                                            ? _c(
                                                                "vs-tooltip",
                                                                {
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    margin:
                                                                      "0 2px",
                                                                    cursor:
                                                                      "pointer"
                                                                  },
                                                                  attrs: {
                                                                    text: _vm
                                                                      .$t(
                                                                        "message.chooseserial"
                                                                      )
                                                                      .toLowerCase(),
                                                                    position:
                                                                      "top"
                                                                  }
                                                                },
                                                                [
                                                                  _vm.isSyncWithWarehouse(
                                                                    product
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "badge badge-secondary",
                                                                          staticStyle: {
                                                                            height:
                                                                              "15px",
                                                                            display:
                                                                              "flex",
                                                                            "align-items":
                                                                              "center",
                                                                            "justify-content":
                                                                              "center",
                                                                            "font-size":
                                                                              "9px",
                                                                            position:
                                                                              "relative",
                                                                            top:
                                                                              "-1px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-sd-card"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          [
                                                            _vm.isSinglePriceAndIsNotAvailable(
                                                              product
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "badge badge-danger",
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "9px",
                                                                      position:
                                                                        "relative",
                                                                      top:
                                                                        "-1px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.productisnotavailable"
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.isSinglePriceAndOutOfStock(
                                                              product
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "badge badge-danger",
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "9px",
                                                                      position:
                                                                        "relative",
                                                                      top:
                                                                        "-1px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.outofstock"
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-right price col-4"
                                                    },
                                                    [
                                                      _vm.isFixedPrice(product)
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.getNumber(
                                                                    product
                                                                      .prices[0]
                                                                      .price
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ])
                                                        : _vm.isCustomPrice(
                                                            product
                                                          )
                                                        ? _c("span", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "comma"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.variableprice"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            product.prices
                                                              .length == 1 &&
                                                            product.modifiers
                                                              .length > 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "comma"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.modifiers"
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ])
                                                        : _c("span", [
                                                            product.prices
                                                              .length > 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "comma"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "apps.pos.message.prices",
                                                                            {
                                                                              number:
                                                                                product
                                                                                  .prices
                                                                                  .length
                                                                            }
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            product.modifiers
                                                              .length > 0
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "comma"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.modifiers"
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "hint" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.pressentertoselect"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.display.type == "discount"
          ? _c("div", { staticClass: "container-items list" }, [
              _c(
                "ul",
                { staticClass: "wrapper-items row" },
                _vm._l(_vm.filterDiscounts, function(discount, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "outer-item col-12",
                      on: {
                        click: function($event) {
                          return _vm.selectedDiscount(discount)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "item col-12 row no-margin active",
                          staticStyle: { height: "48px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "details row no-margin align-items-center",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-left pname col-8",
                                  staticStyle: {
                                    height: "100%",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "center"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "_pname",
                                      staticStyle: {
                                        float: "left",
                                        "margin-right": "10px"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-tag mr-2",
                                        staticStyle: { color: "#6C7A86" }
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(discount.discount_name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-right price col-4" },
                                [
                                  discount.value_type == "percentage"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(discount.value_amount) + "%"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  discount.value_type == "number"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNumber(discount.value_amount)
                                          ) +
                                            " " +
                                            _vm._s(_vm.currency)
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "orders-section" },
        [
          _vm.display.search
            ? _c("div", {
                staticClass: "overlay-disabled",
                on: {
                  click: function($event) {
                    return _vm.setPosDisplay({ search: false })
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.use_queue
            ? _c("queuebutton-view", {
                staticClass: "btn-queue",
                attrs: { loaded: _vm.loaded }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.use_table
            ? _c("tablebutton-view", { staticClass: "btn-table" })
            : _vm._e(),
          _vm._v(" "),
          _vm.use_dining
            ? _c("diningbutton-view", { staticClass: "btn-dining" })
            : _vm._e(),
          _vm._v(" "),
          _vm.user_customer
            ? _c("customerbutton-view", { staticClass: "btn-customer" })
            : _vm._e(),
          _vm._v(" "),
          _c("orderlist-view", {
            staticClass: "order-list",
            attrs: { disabled: "false" }
          }),
          _vm._v(" "),
          _c("optionsbutton-view", { staticClass: "btn-options" }),
          _vm._v(" "),
          _c("totalprice-view", {
            staticClass: "total-price",
            attrs: { disabled: "false" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseSelectLotNumberModal", {
        attrs: {
          show: _vm.lotModal.show,
          loading: _vm.lotModal.loading,
          lots: _vm.lotList,
          selected: _vm.lot.selected,
          index: 0,
          skuId: _vm.lot.skuId
        },
        on: {
          onClose: _vm.handleCloseLotModal,
          onCancel: _vm.handleCancleLotModal,
          onSubmit: _vm.handleSumitLotModal,
          onSortChange: _vm.handleSortLotChange
        }
      }),
      _vm._v(" "),
      _c("BaseSelectSerialNumberModal", {
        attrs: {
          show: _vm.serialModal.show,
          loading: _vm.serialModal.loading,
          serials: _vm.serialList,
          selected: _vm.serial.selected,
          index: 0,
          skuId: _vm.serial.skuId
        },
        on: {
          onClose: _vm.handleCloseSerialModal,
          onCancel: _vm.handleCancleSerialModal,
          onSubmit: _vm.handleSumitSerialModal,
          onSortChange: _vm.handleSortSerialChange
        }
      }),
      _vm._v(" "),
      _vm.isShowNotificationDropdown
        ? _c(
            "BaseDropdownRich",
            {
              attrs: { idRef: "notification-bell", width: 600 },
              on: {
                onClickOutside: function($event) {
                  _vm.isShowNotificationDropdown = false
                }
              }
            },
            [
              _c("BaseNotificationList", {
                attrs: {
                  title: _vm.$t("message.notifications"),
                  items: _vm.notifications,
                  limitItems: 10
                },
                on: { onClickReadAll: _vm.handleClickReadNotifyAll },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item",
                      fn: function(ref) {
                        var item = ref.itemData
                        return [
                          _vm.NEED_APPROVE_ACCESS_STATUSES.concat(
                            _vm.NEED_APPROVE_ORDERS_STATUSES
                          ).includes(item.code)
                            ? _c("BaseNotificationItemApprove", {
                                attrs: {
                                  code: item.code,
                                  platform: item.platform,
                                  dateTime: item.created_at,
                                  queueNumber: item.queue_number,
                                  tableNumber: item.table_number,
                                  orderDetail: _vm.getNotifyDetailText(
                                    item.metadata
                                  ),
                                  isRead: item.is_read,
                                  responseStatus: item.metadata.responseStatus
                                },
                                on: {
                                  onClickReject: function($event) {
                                    return _vm.handleClickReject(item)
                                  },
                                  onClickApprove: function($event) {
                                    return _vm.handleClickApprove(item)
                                  },
                                  onClickViewOrderNo: function($event) {
                                    return _vm.handleClickViewOrderNo(item)
                                  }
                                }
                              })
                            : _c("BaseNotificationItemSimple", {
                                attrs: {
                                  code: item.code,
                                  platform: item.platform,
                                  dateTime: item.created_at,
                                  queueNumber: item.queue_number,
                                  tableNumber: item.table_number,
                                  orderDetail: _vm.getNotifyDetailText(
                                    item.metadata
                                  ),
                                  isRead: item.is_read
                                },
                                on: {
                                  onClickRead: function($event) {
                                    return _vm.handleClickReadNotify(item)
                                  },
                                  onClickViewOrderNo: function($event) {
                                    return _vm.handleClickViewOrderNo(item)
                                  }
                                }
                              })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1858124771
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("BaseBModalQRCodeForm", {
        attrs: {
          modalTitle: _vm.$t("apps.pos.message.createnewqrcode"),
          formType: "create",
          isSubmitted: _vm.isSubmittedQRCodeForm,
          branches: [_vm.branch],
          posSessions: [_vm.posSession],
          defaultValues: _vm.defaultValues,
          qrcode: _vm.qrcode
        },
        on: { onSubmit: _vm.handleSubmitQRCodeForm }
      }),
      _vm._v(" "),
      _c("BaseBModalQRCodeImage", { attrs: { qrcode: _vm.qrcode } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 d-none d-lg-block text-center" }, [
      _c("img", {
        staticStyle: { position: "relative", top: "-1px" },
        attrs: { src: require("./../../../../../../assets/logo-11.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dccae3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dccae3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/ChooseProduct.vue
// module id = null
// module chunks = 